<template>
    <div class="configurations-container">
        <template v-if="isLoadingStartingData">
            <SpeenComponent style="padding: 5ch 0;" :isAutomatic="true" :ringWidth="14" :spinnerSize="15"
                :isverticalAligned="true" />
        </template>
        <template v-else>
            <div class="card-container">
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-header-content">Valores por defecto</h3>
                    </div>
                    <div class="card-body">
                        <div class="card-body-section">
                            <h5 class="card-body-section-content">
                                Tiempo de ciclo ideal por defecto de los artículos
                                <span class="configuration-changing-value">
                                    <button class="general-button"
                                    @click="decrementDefaultReferenceIct" :disabled="defaultReferenceIct <= 1"
                                    aria-label="Disminuir">-</button>
                                    {{ defaultReferenceIct }}
                                    <button class="general-button"
                                    @click="incrementDefaultReferenceIct" aria-label="Aumentar">+</button>
                                </span>
                            </h5>
                            <button class="general-button" @click="changeDefaultReferenceIct()">Cambiar</button>
                        </div>
                        <div class="card-body-section">
                            <h5 class="card-body-section-content">
                                Eficiencia por defecto de las máquinas (%)
                                <span class="configuration-changing-value">
                                    <button class="general-button"
                                        @click="decrementDefaultMachineEfficiencyPct" :disabled="defaultMachineEfficiencyPct <= 1"
                                        aria-label="Disminuir">-</button>
                                    {{ defaultMachineEfficiencyPct }}
                                    <button class="general-button"
                                        @click="incrementDefaultMachineEfficiencyPct" aria-label="Aumentar">+</button>
                                </span>
                            </h5>
                            <button class="general-button" @click="changeDefaultMachineEfficiencyPct()">Cambiar</button>
                        </div>
                    </div>
                </div>
            </div>
            <transition name="slide-fade">
                <ActionConfirmModal v-if="showActionConfirmModal" :contentMessage="contentMessage"
                    :closeModal="closeModal" :methodForProp="methodForProp" />
            </transition>
        </template>
    </div>
</template>

<script>

import ActionConfirmModal from "../../common/components/modals/ActionConfirmModal.vue";
import SpeenComponent from "../../common/components/SpeenComponent.vue";
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from '../../common/utils.js';

export default {
    name: "AdminConfigurations",
    components: {
        ActionConfirmModal,
        SpeenComponent,
    },
    data() {
        return {
            isLoadingStartingData: true,
            showActionConfirmModal: false,
            contentMessage: "",
            methodForProp: "",
            defaultReferenceIct: 0,
            defaultMachineEfficiencyPct: 0
        };
    },
    methods: {
        resetMachineValues() {
            this.methodForProp = this.resetMachineValuesFunction;
            this.contentMessage = '¿Restablecer valores de unidad de los records?';
            this.showActionConfirmModal = true;
        },
        closeModal() {
            this.showActionConfirmModal = false;
        },
        getStartingData() {
            this.isLoadingStartingData = true;
            axios.get('/api/admin/configurations/starting-data')
                .then(response => {
                    this.defaultReferenceIct = response.data.defaultReferenceIct;
                    this.defaultMachineEfficiencyPct = response.data.defaultMachineEfficiencyPct;
                    this.isLoadingStartingData = false;
                })
                .catch(error => {
                    console.error('Error fetching starting data:', error);
                    showCustomErrorSweetAlert(error.response.data);
                });
        },
        decrementDefaultReferenceIct() {
            this.defaultReferenceIct--;
        },
        incrementDefaultReferenceIct() {
            this.defaultReferenceIct++;
        },
        changeDefaultReferenceIct() {
            this.methodForProp = this.changeDefaultReferenceIctFunction;
            this.contentMessage = `¿Cambiar el tiempo de ciclo ideal por defecto de los artículos a ${this.defaultReferenceIct}?`;
            this.showActionConfirmModal = true;
        },
        changeDefaultReferenceIctFunction() {
            axios.patch('/api/admin/configurations/change-default-reference-ict', {
                defaultReferenceIct: this.defaultReferenceIct
            })
                .then(response => {
                    showCustomSuccessSweetAlert('Tiempo de ciclo ideal por defecto de los artículos actualizado correctamente.');
                })
                .catch(error => {
                    showCustomErrorSweetAlert(error.response.data);
                })
                .finally(() => {
                    this.showActionConfirmModal = false;
                });
        },
        decrementDefaultMachineEfficiencyPct() {
            this.defaultMachineEfficiencyPct--;
        },
        incrementDefaultMachineEfficiencyPct() {
            this.defaultMachineEfficiencyPct++;
        },
        changeDefaultMachineEfficiencyPct() {
            this.methodForProp = this.changeDefaultMachineEfficiencyPctFunction;
            this.contentMessage = `¿Cambiar la eficiencia por defecto de las máquinas a ${this.defaultMachineEfficiencyPct}%?`;
            this.showActionConfirmModal = true;
        },
        changeDefaultMachineEfficiencyPctFunction() {
            axios.patch('/api/admin/configurations/change-default-machine-efficiency-pct', {
                defaultMachineEfficiencyPct: this.defaultMachineEfficiencyPct
            })
                .then(response => {
                    showCustomSuccessSweetAlert('Eficiencia por defecto de las máquinas actualizada correctamente.');
                })
                .catch(error => {
                    showCustomErrorSweetAlert(error.response.data);
                })
                .finally(() => {
                    this.showActionConfirmModal = false;
                });
        },
    },
    mounted() {
        this.getStartingData();
    },
};
</script>